import PropTypes from 'prop-types'

import {List, Map} from 'immutable'
import {useState} from 'react'
import {connect} from 'react-redux'

import {Stack, Typography} from '@mui/material'

import AddDeputyModal from '../../../../../dashboard/src/components/corp_max_deputies/add/AddDeputyModal'
import LinkButton from '../../../../../shared_components/mui_base_components/link_button/LinkButton'

import {useDeputyData, useEverplanData} from '../../../../../lib/hooks'
import {currentUserConfig} from '../../../../../lib/userTools'

import './addDraftDeputyForClient.scss'

const AddDraftDeputyForClient = ({clientEverplanId, ...otherProps}) => {
  const {deputies} = useDeputyData(clientEverplanId)
  const {itemResponses, newContacts} = useEverplanData(clientEverplanId)

  const [isAddDeputyModalVisible, setIsAddDeputyModalVisible] = useState(false)

  return (
    <Stack className='add-draft-deputy-for-client' direction='row' spacing={1}>
      <Typography className='prompt' component='span'>
        You can add Deputies to this Everplan.
      </Typography>
      <LinkButton
        className='draft-invite-link'
        onClick={() => setIsAddDeputyModalVisible(true)}>
        Draft an invite
      </LinkButton>
      {
        isAddDeputyModalVisible && (
          <AddDeputyModal
            clientEverplanId={clientEverplanId}
            context='pro_client_dashboard'
            deputies={deputies}
            exit={() => setIsAddDeputyModalVisible(false)}
            itemResponses={itemResponses}
            newContacts={newContacts}
            {...otherProps}
          />
        )
      }
    </Stack>
  )
}

AddDraftDeputyForClient.propTypes = {
  clientEverplanId: PropTypes.string.isRequired,
  clientFirstName: PropTypes.string.isRequired,
  clientSeatId: PropTypes.number.isRequired,
  deputies: PropTypes.instanceOf(List),
  userConfig: PropTypes.instanceOf(Map)
}

const mapStateToProps = state => ({userConfig: currentUserConfig(state.api)})

export default connect(mapStateToProps)(AddDraftDeputyForClient)
